export const emailIsValid = (value = "") => {
    const emailMatch =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))(?<!-)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const passesRegex = emailMatch.test(value);

    const [address, domain] = value.split("@");
    return (
        passesRegex &&
        !!address &&
        !!domain &&
        address.length < 65 &&
        domain.length < 254
    );
};
